// File: /src/pages/IssuedWallets.js
import React, { useEffect, useState } from 'react';
import './IssuedWallets.css';
import { getAllVCs } from '../../api/ssiAPI';
import {
  FaCheckCircle,
  FaCertificate,
  FaBan,
  FaEye,
  FaTrash,
  FaQrcode
} from 'react-icons/fa';
import Swal from 'sweetalert2';
import {
  deleteUserByEarthId,
  deleteWalletMappingByEarthId,
  getUserDetailsByEarthId,
  getWalletMappingsByIssuer
} from '../../api/wallet-mappingAPI';
import { getMe } from '../../api/loginAPI';

function IssuedWallets() {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [allCertificates, setAllCertificates] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
   const darkMode = document.body.classList.contains('dark-mode')

const [user, setUser] = useState(null);
  
    useEffect(() => {
      async function fetchUser() {
        const userData = await getMe();
        console.log('UserData', userData)
        setUser(userData);
      }
      fetchUser();
    }, []);

  useEffect(() => {
//   const issuerId = sessionStorage.getItem('userId');
//   console.log('This is userID:', issuerId)
  if (user) {
    getWalletMappingsByIssuer(user.Id).then(setAllCertificates);
    console.log('these are the wallets',allCertificates)
  }
}, [user]);

const handleViewUser = async (earthId) => {
  const user = await getUserDetailsByEarthId(earthId);
  if (user) {
// User Details Modal
Swal.fire({
  title: 'User Details',
  html: `
    <div style="font-family: Arial, sans-serif; font-size: 14px; padding: 10px;">
      <table style="width: 100%; border-collapse: collapse;">
        <tr>
          <td style="text-align: left; font-weight: 600; padding: 6px 4px;">Name</td>
          <td style="text-align: right; padding: 6px 4px;">${user.firstname} ${user.lastname}</td>
        </tr>
        <tr>
          <td style="text-align: left; font-weight: 600; padding: 6px 4px;">Email</td>
          <td style="text-align: right; padding: 6px 4px;">${user.email}</td>
        </tr>
        <tr>
          <td style="text-align: left; font-weight: 600; padding: 6px 4px;">Phone</td>
          <td style="text-align: right; padding: 6px 4px;">${user.phone}</td>
        </tr>
        <tr>
          <td style="text-align: left; font-weight: 600; padding: 6px 4px;">EarthID</td>
          <td style="text-align: right; padding: 6px 4px;">${user.earthId}</td>
        </tr>
      </table>
    </div>
  `,
  width: 500,
  background: document.body.classList.contains('dark-mode') ? '#1f2937' : '#fff',
  color: document.body.classList.contains('dark-mode') ? '#f9fafb' : '#111',
  showCloseButton: true,
  confirmButtonColor: '#3085d6',
  confirmButtonText: 'Okay',
  customClass: {
    popup: 'swal-custom'
  }
  
 
});

  } else {
    //Swal.fire('Error', 'Failed to fetch user info', 'error');
     Swal.fire({
  icon: 'error',
  title: 'Error',
  text: 'Failed to fetch user info.',
  background: document.body.classList.contains('dark-mode') ? '#1f2937' : '#fff',
  color: document.body.classList.contains('dark-mode') ? '#f9fafb' : '#111',
  customClass: {
    popup: 'swal-custom'
  }
});
  }
};

const handleDeleteUser = async (earthId) => {
  const userData = await getUserDetailsByEarthId(earthId);
  console.log('This is the userData:', userData);


  if (!userData?.publicKey) {
    // Swal.fire({
    //   title: 'Error',
    //   text: 'Public key not found. Cannot delete user.',
    //   icon: 'error',
    //   background: darkMode ? '#1e1e2f' : '#ffffff',
    //   color: darkMode ? '#f1f1f1' : '#000000',
    //   confirmButtonColor: darkMode ? '#9a0cec' : '#3085d6',
    //   iconColor: darkMode ? '#ff6b6b' : undefined,
    // });

     Swal.fire({
  icon: 'error',
  title: 'Error',
  text: 'Public key not found. Cannot delete user.',
  background: document.body.classList.contains('dark-mode') ? '#1f2937' : '#fff',
  color: document.body.classList.contains('dark-mode') ? '#f9fafb' : '#111',
  customClass: {
    popup: 'swal-custom'
  }
});
    return;
  }

  const confirm = await Swal.fire({
    title: 'Confirm Delete',
    text: `Delete user ${userData.username}?`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'Cancel',
    background: darkMode ? '#1e1e2f' : '#ffffff',
    color: darkMode ? '#f1f1f1' : '#000000',
    confirmButtonColor: darkMode ? '#9a0cec' : '#3085d6',
    cancelButtonColor: darkMode ? '#555' : '#aaa',
    iconColor: darkMode ? '#ffd369' : undefined,
  });

  if (confirm.isConfirmed) {
    const res = await deleteUserByEarthId(earthId, userData.publicKey);
    console.log('Delete API response:', res);

    if (res?.earthId === earthId || res?.username === userData.username) {
      const mappingDeleteRes = await deleteWalletMappingByEarthId(earthId);
      console.log("✅ Mapping delete response:", mappingDeleteRes);

      if (!mappingDeleteRes) {
        Swal.fire({
          title: 'Error',
          text: 'Failed to delete user.',
          icon: 'error',
          background: darkMode ? '#1e1e2f' : '#ffffff',
          color: darkMode ? '#f1f1f1' : '#000000',
          confirmButtonColor: darkMode ? '#9a0cec' : '#3085d6',
          iconColor: darkMode ? '#ff6b6b' : undefined,
        });
        return;
      }

      if (user.Id) {
        const updatedList = await getWalletMappingsByIssuer(user.Id);
        setAllCertificates(updatedList);
        setCurrentPage(1);
      }

      Swal.fire({
        title: 'Deleted!',
        text: 'User has been deleted.',
        icon: 'success',
        background: darkMode ? '#1e1e2f' : '#ffffff',
        color: darkMode ? '#f1f1f1' : '#000000',
        confirmButtonColor: darkMode ? '#9a0cec' : '#3085d6',
        iconColor: darkMode ? '#00ffae' : undefined,
      });

    } else {
      Swal.fire({
        title: 'Error',
        text: 'Failed to delete user.',
        icon: 'error',
        background: darkMode ? '#1e1e2f' : '#ffffff',
        color: darkMode ? '#f1f1f1' : '#000000',
        confirmButtonColor: darkMode ? '#9a0cec' : '#3085d6',
        iconColor: darkMode ? '#ff6b6b' : undefined,
      });
    }
  }
};

  const filteredCertificates = allCertificates.filter(cert => {
    const certDate = new Date(cert.created_at);
    const from = startDate ? new Date(startDate) : null;
    const to = endDate ? new Date(endDate) : null;
    return (!from || certDate >= from) && (!to || certDate <= to);
  });

  const handleView = async (earthId) => {
    const user = await getUserDetailsByEarthId(earthId);
    if (user) {
      Swal.fire({
        title: 'User Details',
        html: `
          <strong>Email:</strong> ${user.email}<br/>
          <strong>Username:</strong> ${user.username}<br/>
          <strong>Phone:</strong> ${user.phone}<br/>
          <strong>Public Key:</strong><br/><small>${user.publicKey}</small>
        `
      });
    } else {
      Swal.fire('Error', 'Failed to fetch user info', 'error');
    }
  };

  const handleDelete = async (earthId) => {
    const user = await getUserDetailsByEarthId(earthId);
    if (!user?.publicKey) {
      Swal.fire('Error', 'Public key not found. Cannot delete user.', 'error');
      return;
    }

    const confirm = await Swal.fire({
      title: 'Confirm Delete',
      text: `Delete user ${user.username}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel'
    });

    if (confirm.isConfirmed) {
      const res = await deleteUserByEarthId(earthId, user.publicKey);
      if (res?.success || res?.message?.toLowerCase()?.includes('success')) {
        Swal.fire('Deleted!', 'User has been deleted.', 'success');

        // Refresh data
        const updatedData = await getAllVCs();
        setAllCertificates(updatedData?.response || []);
      } else {
        Swal.fire('Error', 'Failed to delete user.', 'error');
      }
    }
  };

  const totalIssued = allCertificates.length;
  const activeCount = allCertificates.length;
  const revokedCount = 0;

  return (
    <div className="page issued-layout">
      <h2 className="issued-title">Issued Wallets - EarthIDs</h2>

      <div className="card-row">
        <div className="report-card issued">
          <FaCertificate className="card-icon" />
          <div>
            <h3>{totalIssued}</h3>
            <p>Total Issued</p>
          </div>
        </div>
        <div className="report-card active">
          <FaCheckCircle className="card-icon" />
          <div>
            <h3>{activeCount}</h3>
            <p>Active Wallets</p>
          </div>
        </div>
        <div className="report-card revoked">
          <FaBan className="card-icon" />
          <div>
            <h3>{revokedCount}</h3>
            <p>Revoked Wallets</p>
          </div>
        </div>
      </div>

      <div className="filters">
        <label>
          Start Date:
          <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
        </label>
        <label>
          End Date:
          <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
        </label>
      </div>

      <div className="table-section">
        <table>
          <thead>
             <tr>
            <th>Sr No</th>
            <th>EarthID ID</th>
            <th>Issuer ID</th>
            <th>Created At</th>
            {/* <th className="icon-col">QR</th> */}
             <th className="icon-col">View</th>
            <th className="icon-col">Delete</th>
          </tr>
          </thead>
           <tbody>
                    {filteredCertificates.map((mapping, index) => (
                      <tr key={mapping.id || mapping.wallet_id}>
                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                        <td>{mapping.wallet_id}</td>
                        <td>{mapping.issuer_id}</td>
                        <td>{mapping.created_at}</td>
                        {/* <td className="icon-col">
            <FaQrcode
              className="table-icon icon-qr"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                const qrData = {
                  earthId: mapping.wallet_id,
                  bucketName: `idv-sessions-${mapping.issuer_id?.toLowerCase()}`
                };
                const encrypted = btoa(JSON.stringify(qrData));
                Swal.fire({
                  title: 'QR Code',
                  html: `<img src="https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(encrypted)}" />`,
                   background: document.body.classList.contains('dark-mode') ? '#1f2937' : '#fff',
  color: document.body.classList.contains('dark-mode') ? '#f9fafb' : '#111',
  customClass: {
    popup: 'swal-custom'
  }
                });
              }}
            />
          </td> */}
          
                        <td className="icon-col">
            <FaEye
              className="table-icon icon-view"
              style={{ cursor: 'pointer' }}
              onClick={() => handleViewUser(mapping.wallet_id)}
            />
          </td>
          <td className="icon-col">
            <FaTrash
              className="table-icon icon-delete"
              style={{ cursor: 'pointer' }}
              onClick={() => handleDeleteUser(mapping.wallet_id)}
            />
          </td>
                      </tr>
                    ))}
                  </tbody>
        </table>
      </div>
    </div>
  );
}

export default IssuedWallets;
